class CollectionAutoScroll {
  constructor() {
    this.container = document.getElementById('ProductGridContainer');
    this.productGrid = document.querySelector('.product-grid');
    this.nextPageLink = document.querySelector('.pagination__next a');
    this.isLoading = false;
    this.observer = null;
    
    if (!this.container || !this.productGrid) return;
    
    this.init();
  }
  
  init() {
    // Create loading indicator
    this.loadingIndicator = document.createElement('div');
    this.loadingIndicator.className = 'loading-indicator hidden';
    this.loadingIndicator.innerHTML = `
      <div class="loading-spinner">
        <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
      <p>Loading more products...</p>
    `;
    this.container.appendChild(this.loadingIndicator);
    
    // Set up Intersection Observer for more modern approach
    this.setupObserver();
    
    // Fallback to scroll event if IntersectionObserver isn't supported
    if (!this.observer) {
      window.addEventListener('scroll', this.handleScroll.bind(this));
    }
  }
  
  setupObserver() {
    if ('IntersectionObserver' in window) {
      const options = {
        root: null,
        rootMargin: '500px',
        threshold: 0
      };
      
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isLoading && this.nextPageLink) {
            this.loadMoreProducts();
          }
        });
      }, options);
      
      // Observe the loading indicator
      this.observer.observe(this.loadingIndicator);
    }
  }
  
  handleScroll() {
    const scrollPosition = window.innerHeight + window.scrollY;
    const pageHeight = document.body.offsetHeight - 500; // Load 500px before bottom
    
    if (scrollPosition >= pageHeight && !this.isLoading && this.nextPageLink) {
      this.loadMoreProducts();
    }
  }
  
  async loadMoreProducts() {
    this.isLoading = true;
    this.loadingIndicator.classList.remove('hidden');
    
    try {
      const response = await fetch(this.nextPageLink.href);
      const html = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newProducts = doc.querySelector('.product-grid');
      const newNextPageLink = doc.querySelector('.pagination__next a');
      
      if (newProducts) {
        // Create a temporary container to hold the new products
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = newProducts.innerHTML;
        
        // Append each new product card to the existing grid
        while (tempDiv.firstChild) {
          this.productGrid.appendChild(tempDiv.firstChild);
        }
      }
      
      // Update the next page link or remove observer if no more pages
      if (newNextPageLink) {
        this.nextPageLink.href = newNextPageLink.href;
      } else {
        this.loadingIndicator.textContent = 'All products loaded';
        if (this.observer) this.observer.unobserve(this.loadingIndicator);
      }
    } catch (error) {
      console.error('Error loading more products:', error);
      this.loadingIndicator.textContent = 'Error loading more products';
    } finally {
      this.isLoading = false;
      setTimeout(() => {
        this.loadingIndicator.classList.add('hidden');
      }, 1000);
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new CollectionAutoScroll();
});